import { connect } from 'react-redux';
import { compose } from 'redux';
import withReducer from '@Hooks/withReducer';

import { quickSearchAutosuggestReducerKey } from './QuickSearchAutosuggestConstants';
import { inputValue, isLoading } from './QuickSearchAutosuggestSelectors';
import { fetchAutosuggestMatches, setInputValue, onSelect } from './QuickSearchAutosuggestActions';
import { reducer } from './QuickSearchAutosuggestReducer';

import QuickSearchAutosuggest from './QuickSearchAutosuggest';

function mapStateToProps(state) {
  return {
    inputValue: inputValue(state),
    isLoading: isLoading(state),
  };
}

function mapDispatchToProps(dispatch, ownProps) {
  return {
    fetchAutosuggestMatches: (...args) => dispatch(fetchAutosuggestMatches(...args)),
    inputOnChange: (...args) => {
      if (ownProps.onChange) {
        ownProps.onChange(...args); // call parent onChange
      }
      return dispatch(setInputValue(...args));
    },
    onSelect: (...args) => dispatch(onSelect(...args)),
  };
}

export default compose(
  withReducer(quickSearchAutosuggestReducerKey, reducer, true),
  connect(mapStateToProps, mapDispatchToProps)
)(QuickSearchAutosuggest);
